module.exports = __webpack_public_path__ + "static/img/day.eb858859.jpg";